import React from 'react';
import * as PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FileInput } from '@medflex/components/stories/FileUpload';
import ContextMenu from '@medflex/components/stories/ContextMenu';
import { TRACKING_ACTIONS, TRACKING_ELEMENT_TYPES, trackEvent } from '@medflex/utils/Tracking';
import { showSuccessToast } from '@medflex/components/stories/Toast';
import { IconAddSolid, IconAttachment, IconCopy } from '@medflex/components/stories/Icons';
import Button from '@medflex/components/stories/Button';
import useChatMessagesExport from '../../hooks/useChatMessagesExport';

const StandaloneChatContextMenu = ({ registerFileInput, t, isWideScreen, isDisabled }) => {
  const chatMessagesExport = useChatMessagesExport();
  const handleCopy = () => {
    trackEvent({
      zone: 'StandaloneChat',
      action: TRACKING_ACTIONS.CLICK,
      elementType: TRACKING_ELEMENT_TYPES.BUTTON,
      actionText: t('global:actions.copy_history.menu'),
    });
    showSuccessToast(
      t('global:toasts.copy.title'),
      t('global:toasts.copy.text', {
        allowHtml: true,
      }),
      {
        toastId: 'SessionAddParticipantSuccess',
      },
    );
  };

  return (
    <FileInput {...registerFileInput()}>
      {({ select }) => (
        <ContextMenu>
          <ContextMenu.Menu closeButtonLabel={t('global:actions.close_button')}>
            <ContextMenu.Group>
              <ContextMenu.Item onClick={select}>
                <span className="flex rotate-90 transform items-center text-lg text-blue-500">
                  <IconAttachment size="text" />
                </span>
                <span className="ml-3">{t('global:actions.file_upload.menu')}</span>
              </ContextMenu.Item>
            </ContextMenu.Group>
            <ContextMenu.Group>
              <CopyToClipboard text={chatMessagesExport} onCopy={handleCopy}>
                <ContextMenu.Item>
                  <span className="flex items-center text-lg text-blue-500">
                    <IconCopy size="text" />
                  </span>
                  <span className="ml-3">{t('global:actions.copy_history.menu')}</span>
                </ContextMenu.Item>
              </CopyToClipboard>
            </ContextMenu.Group>
          </ContextMenu.Menu>
          <ContextMenu.Trigger>
            {({ triggerRef, isVisible }) => (
              <Button
                kind={isWideScreen ? 'primary' : 'primary:ghost'}
                className="lg:mx-2"
                shape={isWideScreen ? 'square' : 'circle'}
                innerRef={triggerRef}
                isActive={isVisible}
                isDisabled={isDisabled}
              >
                <IconAddSolid size="6" />
              </Button>
            )}
          </ContextMenu.Trigger>
        </ContextMenu>
      )}
    </FileInput>
  );
};

StandaloneChatContextMenu.propTypes = {
  registerFileInput: PropTypes.func,
  t: PropTypes.func,
  isWideScreen: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default StandaloneChatContextMenu;
